import {
  FOREIGN_RESIDENCY_DATA_REQUEST,
  FOREIGN_RESIDENCY_DATA_SUCCESS,
  FOREIGN_RESIDENCY_DATA_FAIL,
} from '../constants/foreignResidencyConstants';

export const foreignResidencyReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case FOREIGN_RESIDENCY_DATA_REQUEST:
      return { loading: true, formData: [] };
    case FOREIGN_RESIDENCY_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case FOREIGN_RESIDENCY_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
